// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
// import Directives from '@/directives'
import vSelect from 'vue-select'
import msgBR from 'vee-validate/dist/locale/pt_BR'
import VeeValidate, {Validator} from 'vee-validate'

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import money from 'v-money-plus'
import rate from 'vue-rate'

import VueTheMask from 'vue-the-mask'
import vbclass from 'vue-body-class'
import VueCarousel from 'vue-carousel'
import Paginate from 'vuejs-paginate'
import Toasted from 'vue-toasted'
import * as VueGoogleMaps from 'vue2-google-maps'
import directives from '@/directives'

Vue.component('v-select', vSelect)
Vue.use(VueTheMask)
Vue.use(VueCarousel)
Vue.use(VeeValidate)
Validator.localize('pt_BR', msgBR)
Vue.use(money, {decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})
Vue.use(rate)

Vue.use(vbclass, router)

Vue.component('paginate', Paginate)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

router.beforeEach((to, from, next) => {
  let user = store.getters.user
  Vue.toasted.clear()

  if (to.meta && to.meta.requireAuth) {
    if (user) {
      next()
    } else {
      next('/login')
    }
  }

  next()
})

window.$ = window.jQuery = require('jquery')
require('popper.js')
require('bootstrap')
require('slick-carousel/slick/slick.css')
require('slick-carousel/slick/slick-theme.css')
require('slick-carousel')

require('perfect-scrollbar')
require('./css/main.css')
require('./styles/style-custom.scss')
require('./assets/icon-fonts/themify/themify-icons.css')
require('vue2-dropzone/dist/vue2Dropzone.css')

Vue.use(VueGoogleMaps, {
  installComponents: true,
  load: {
    key: 'AIzaSyDkKIKv_5RypDjSm7Fy20vldKy_BhYyQYI',
    libraries: 'places',
    language: 'pt',
    region: 'BR'
  }
})

let defaultEndpoint = require('@/endpoint')

const Options = {
  position: this.$mq === 'sm' ? 'bottom-center' : 'top-center',
  singleton: true,
  fullWidth: this.$mq === 'sm',
  fitToScreen: this.$mq === 'sm',
  iconPack: 'fontawesome',
  type: 'info'
}
Vue.use(Toasted, Options)

Vue.config.productionTip = false

axios.defaults.baseURL = defaultEndpoint.url

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  filters: {
    money
  },
  directives: directives
})



// WEBPACK FOOTER //
// ./src/main.js